import { useModals } from "@/features/modals/hooks";
import { type WidgetSettingsDefinition, type hfb } from "@repo/api";
import { ListViewItem, warehouseIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { translateHFB } from "@repo/ui";

export const DepartmentSettingsControl = ({
  settingDefinition,
  setting,
  setSetting,
}: {
  settingDefinition: WidgetSettingsDefinition;
  setting: Record<string, any>;
  setSetting: (newSetting: Record<string, object>) => void;
}) => {
  const { pushModal } = useModals();
  const selectedDepartments = (setting[settingDefinition.id] as hfb[]) ?? [];

  return (
    <ListViewItem
      control="navigational"
      title={t("label.department")}
      description={
        selectedDepartments.length > 0
          ? selectedDepartments
              .map((department) => translateHFB(department))
              .join(", ")
          : undefined
      }
      onClick={() => {
        pushModal({
          type: "SELECT_DEPARTMENT",
          selected: selectedDepartments,
          onUpdate: (newDepartments: hfb[]) => {
            setSetting({
              ...setting,
              [settingDefinition.id]: newDepartments,
            });
            return Promise.resolve();
          },
        });
      }}
      leadingIcon={warehouseIcon}
    />
  );
};
